import { render, staticRenderFns } from "./AddImage.vue?vue&type=template&id=ab1632f6&"
import script from "./AddImage.vue?vue&type=script&lang=js&"
export * from "./AddImage.vue?vue&type=script&lang=js&"
import style0 from "./AddImage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports